import React from 'react';

import NoticeBig from '../../modules/notice-big/notice-big';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';

import ErrorIcon from './icons/error.svg';
import SuccessIcon from './icons/success.svg';

import './close-credit-result.scss';

interface CloseCreditResultProps {
  linkContent?: React.ReactNode;
  submitBtn: React.ReactNode;
  success: boolean;
  loading: boolean;
  onClose?: () => void;
}

const SuccessContent = 'Вы успешно оплатили выбранный займ';

const ErrorContent = 'Произошла ошибка';

const CloseCreditResult: React.FC<CloseCreditResultProps> = ({
  submitBtn,
  onClose,
  loading,
  success,
  linkContent,
}) => (
  <TableWrapper>
    <div className="page-blank close-credit__container">
      <div className="page-blank__header">
        <TableHeaderWrapper
          onCloseClick={onClose}
          leftContent="Результат оплаты"
        />
      </div>
      <div className="page-blank__body">
        {!loading ? (
          <>
            {success ? (
              <NoticeBig
                title="Успешная оплата!"
                bottom={submitBtn}
                icon={SuccessIcon}
                text={SuccessContent}
                link={linkContent}
              />
            ) : (
              <NoticeBig
                text={ErrorContent}
                link=""
                icon={ErrorIcon}
                title="Внимание ошибка!"
                bottom={submitBtn}
              />
            )}
          </>
        ) : null}
      </div>
    </div>
  </TableWrapper>
);

export default CloseCreditResult;
